<app-loading
  [loading] = loading
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Usuários"
      Pagina="Usuario"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <div *ngIf="aceitaUsuarios" class="col-md-12 text-right" style="margin-bottom: 10px;">
              <a href="/auth/usuario/novo"><button class="btn btn-primary"><i class="fa fa-plus"></i> Cadastrar</button></a>
            </div>
            <app-tabela titulo="Lista de usuários"
                        placeHolder="Buscar usuario"
                        [colunas]="colunas"
                        [linhas]="linhas"
                        [botaoEditar]= "botaoEditar"
                        linkBotaoEditar="auth/usuario/detalhes"
            ></app-tabela>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
